export default __webpack_public_path__ + "static/media/MONUSCO_santos_cruz.aafdd5c9.jpg";